exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-area[data-v-4f2ff132]{width:50%;padding:12px;text-align:center}", ""]);

// exports
